import AbstractHttpClient from '@/infrastructure/axios/request';
import { logger } from '@/infrastructure/logger';
import { IDetailBySessionIDRequest, IDetailReply, IDetailRequest, IHandleReply, IHandleRequest, IHistoryReply, IHistoryRequest } from '@/proto/alert';
import { TrpcService } from '@/service/trpc';

class AlertServer extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.AlertService,
    });
  }

  /**
   * 获取告警详情
   * @param req
   */
  public async getAlertDetailBySessionID(req: IDetailBySessionIDRequest): Promise<IDetailReply | null> {
    try {
      return await this.trpcPost('DetailBySessionID', req);
    } catch (e) {
      return null;
    }
  }

  /**
   * 获取告警历史列表
   */
  public async getHistoryList(req: IHistoryRequest): Promise<IHistoryReply> {
    try {
      return await this.trpcPost<IHistoryReply>('Histories', req);
    } catch (e) {
      logger.error('getHistoryList e:', e);
      return {
        totalCount: 0,
        alertInfo: [],
      };
    }
  }

  /**
   * 设置处理状态
   */
  public async setHistoryTapdStatus(req: IHandleRequest): Promise<IHandleReply> {
    try {
      return await this.trpcPost<IHandleReply>('Handle', req);
    } catch (e) {
      logger.error('setHistoryTapdStatus e:', e);
      return {};
    }
  }

  /**
   * 获取告警历史详情数据
   */
  public async getHistoryDetail(req: IDetailRequest): Promise<IDetailReply> {
    try {
      return await this.trpcPost('Detail', req);
    } catch (e) {
      logger.error('getHistoryDetail e:', e);
      return {};
    }
  }
}

export const alertService = new AlertServer();
